// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsPage_wrapper__rjhW8","aboveList":"ProjectsPage_aboveList__TBKmW","filter":"ProjectsPage_filter__fQd-W","coverFallback":"ProjectsPage_coverFallback__4WKnU"};